<div class="c-container" #ccontainer [ngStyle]="{padding: 'calc(' + marqueurSize + 'px / 2)'}">
  <ng-content></ng-content>
  <canvas
    #canvas
    [ngClass]="{'c-canvas-edit': canDraw}"
    [width]="dimensionX"
    [height]="dimensionY"
    [ngStyle]="{top: 'calc(' + marqueurSize + 'px / 2)', left: 'calc(' + marqueurSize + 'px / 2)'}"
  ></canvas>

  <canvas
    #geometricCanvas
    [width]="dimensionX"
    [height]="dimensionY"
    [ngStyle]="{top: 'calc(' + marqueurSize + 'px / 2)', left: 'calc(' + marqueurSize + 'px / 2)', display: mode === 'rectangle' || mode === 'ellipse' || mode === 'line' ? 'block' : 'none' }"
  ></canvas>

</div>